import { render, staticRenderFns } from "./MyWallet.vue?vue&type=template&id=12c3edaf&scoped=true"
import script from "./MyWallet.vue?vue&type=script&lang=js"
export * from "./MyWallet.vue?vue&type=script&lang=js"
import style0 from "./MyWallet.vue?vue&type=style&index=0&id=12c3edaf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c3edaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12c3edaf')) {
      api.createRecord('12c3edaf', component.options)
    } else {
      api.reload('12c3edaf', component.options)
    }
    module.hot.accept("./MyWallet.vue?vue&type=template&id=12c3edaf&scoped=true", function () {
      api.rerender('12c3edaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/influencer_panel/MyWallet.vue"
export default component.exports